const Counter = require('@/lib/Utilities/Counter');

class CartLineNumberFactory extends Counter {
}

module.exports = CartLineNumberFactory;
